import { BaseApiTemplateService, Core2Config } from '../../../shared';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TaskRouterQueueSkillLinkContainerModel } from '../../../../../../../models/aggregates/alg/cc/task-router/task-router-queue-skill-link-container.model';

@Injectable({ providedIn: 'root' })
export class TaskRouterQueueSkillLinkService extends BaseApiTemplateService<TaskRouterQueueSkillLinkContainerModel> {
  constructor(http: HttpClient) {
    super();

    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ALG_CC_MODULE +
      'queue-skill-link';

    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ALG_CC_MODULE +
      'queue-skill-link';

    this.httpClient = http;
  }
}
